// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1c488a48","667":"518d85fb","977":"354b15ca"}[chunkId] + ".chunk.js";
};